// extracted by mini-css-extract-plugin
export var content = "moreAboutECHO-module--content--18e96";
export var info = "moreAboutECHO-module--info--e29de";